<template>
  <DefaultLayout class="SettingsView">
    <h1 class="mb-4 display-1">
      Настройки
    </h1>

    <template v-if="currentUser && currentUser.isAdmin">
      <VTabs
        v-model="ui.tabModel"
        background-color="transparent"
        grow
        prev-icon="mdi-chevron-left"
        next-icon="mdi-chevron-right"
        show-arrows
      >
        <VTab :key="0">
          Настройка типов событий
        </VTab>
        <VTab :key="1">
          Настройки пользователей
        </VTab>

        <VTabsItems v-model="ui.tabModel">
          <VTabItem :key="0">
            <EventTypeSettings class="mt-4" />
          </VTabItem>
          <VTabItem :key="1">
            <SubordinatesSettings class="mt-4" />
          </VTabItem>
        </VTabsItems>
      </VTabs>
    </template>
    <VAlert
      v-else
      border="left"
      outlined
      color="primary"
      icon="mdi-account-circle"
    >
      <template v-if="authorized">
        Доступно только администратору
      </template>
      <template v-else>
        Требуется
        <VBtn
          text
          small
          color="primary"
          @click="$store.commit('ui/setLoginModal', { value: true })"
        >
          авторизоваться
        </VBtn>
      </template>
    </VAlert>
  </DefaultLayout>
</template>

<script>
import DefaultLayout from '../layouts/Default'
import EventTypeSettings from '../components/EventTypeSettings'
import SubordinatesSettings from '../components/SubordinatesSettings'

export default {
  name: 'Settings',
  components: {
    SubordinatesSettings,
    EventTypeSettings,
    DefaultLayout,
  },
  data() {
    return {
      ui: {
        tabModel: 0,
      },
    }
  },
  computed: {
    currentUser() { return this.$store.state.user.current },
    authorized() { return !!this.$store.state.auth.token },
  },
}
</script>
